<script lang="ts">
    import { melt, createSeparator } from '@melt-ui/svelte';
    import { cx } from '$lib/utils/cx';

    const {
        elements: { root },
    } = createSeparator({
        decorative: true,
        orientation: 'vertical',
    });
</script>

<div
    use:melt={$root}
    class="flex items-center justify-center h-[64px] shrink-0 px-[12px] py-[12px] bg-white"
>
    <div class={cx('h-full w-[1px] bg-gray-500 transition-opacity', 'opacity-100')} />
</div>
